import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Tag = ({ className, title, bgColor = 'yellow', isPartnership }) => {

    if (!title) {
        return null;
    }

    if (isPartnership) {
        if (title === 'For Sale') {
            bgColor = 'magenta';
        } else if (title === 'For Rent') {
            bgColor = 'linen';
        }
    }

    return (
        <span
            className={`link-reset cursor-pointer inline-flex px5 items-center py2 bg-${bgColor} ${className ? className : ''}`}>
            <p className={'type-style-5 black'}>{title === 'Rented' ? 'Let' : title}</p>
        </span>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    bgColor: PropTypes.oneOf(['yellow', 'white']),
    isPartnership: PropTypes.bool
};

Tag.propTypes = propTypes;

export default Tag;
